import { defineMessages } from 'react-intl';

export const wizardStepMessages = defineMessages({
  edit: {
    defaultMessage: 'Edit',
    id: '6dM4LD',
    description: 'Link to reopen a completed wizard step',
  },
  completed: {
    defaultMessage: 'Completed',
    id: '13B/fL',
    description: 'Accessible label indicating a wizard step is completed',
  },
  requiredFieldsMissing: {
    defaultMessage: 'Required fields missing',
    id: 'df+cl2',
    description: 'Subtitle shown on a wizard step card when required fields have not been filled in',
  },
});
